import type { InjectionKey } from 'vue'
import type { BreadcrumbProps } from '@sgui-plus/components/breadcrumb'

export const BreadcrumbContextKey: InjectionKey<BreadcrumbProps> = Symbol('BreadcrumbContextKey')
